var _rect, _rect2, _rect3, _rect4, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDayDepthWidgetLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 84 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 49,
    fill: "#D2DBEC",
    rx: 8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 41,
    x: 4,
    y: 4,
    fill: "#EFF3F9",
    rx: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 33,
    x: 13,
    y: 7,
    fill: "#BECDFA",
    rx: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 61,
    x: 13,
    y: 40,
    fill: "#BECDFA",
    rx: 0.5,
    transform: "rotate(-90 13 40)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#5F5CF6",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m16 8 4.7 10.4c.2.4.6.6 1 .6H29c.3 0 .6.2.8.4l4.4 6.7c.2.2.5.4.8.4h10c.3 0 .6.2.8.5l4.4 7.5c.2.3.5.5.9.5h14.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF6565",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m16 8 7.7 7.7c.2.2.4.3.7.3H34c.4 0 .7.2.9.5l8 12.5c0 .3.4.5.8.5h11.9c.3 0 .6.2.8.4l4.9 7.2c.2.2.5.4.8.4h11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDayDepthWidgetLight);
export default __webpack_public_path__ + "static/media/day-depth-widget-light.f96a1bbcf793695543557e98a5db9026.svg";
export { ForwardRef as ReactComponent };